import React, { useEffect, useState } from "react";
import styles from "./orders.module.scss";
import axios from "axios";
import cx from "classnames";
import * as moment from "moment-timezone";
import toast, { Toaster } from "react-hot-toast";
import { useInterval } from "../hook/useInterval";
import { DateTime } from "luxon";
import { Duration } from "luxon";
import { useParams } from "@reach/router";
import MansoryLayout from "../layout/mansory.layout";
import DefaultLayout from "../layout/default.layout";

export default function OrdersPage() {
  const params = useParams()
  const [orders, setOrders] = useState([]);
  const api = process.env.REACT_APP_API;
  const [now, setNow] = useState(DateTime.local());
  const [alreadyPlay, setAlreadyPlay] = useState([]);
  const [sound, setSound] = useState(false);
  const [working, setWorking] = useState(false);
  const REFRESH = {
    desktop: 15000,
    tablet: 20000
  }

  // let audio = new Audio("/Autopilot-disconnect.mp3");

  const initWork = () => {
    var audio = document.getElementById("myAudio");
    audio.volume = 0;
    audio.loop = true;
    audio.play();
    setWorking(true);
  };

  const start = () => {
    
    let audio = document.getElementById("myAudio");
    if(!params.device) {
      audio.volume = 1;
      setSound(true);
    } else {
      audio.volume = 1;
      setSound(true);

      setTimeout(() => {
        audio.volume = 0;
        setSound(false);
      }, 5000)
    }
  };

  const stop = () => {
    var audio = document.getElementById("myAudio");
    audio.volume = 0;
    setSound(false);
  };

  useInterval(() => {
    setNow(DateTime.local());
  }, 500);

  useInterval(() => {
    refresh();
  }, REFRESH[params.device ?? 'tablet']);

  useInterval(() => {
    var audio = document.getElementById("myAudio");
    if (audio.paused) {
      setSound(false);
      setWorking(false);
    }
  }, 1000);

  const returnTime = (time) => {
    const diff = now.diff(DateTime.fromISO(time));
    let _total = Duration.fromMillis(diff.milliseconds).toFormat("hh:mm:ss");
    return _total;
  };

  const delivered = async (id) => {
    const promise = axios
      .post(`${api}kot/edit`, {
        id: id,
        status: "ENTREGADA",
      })
      .then(() => console.log("entregada"));
    toast
      .promise(promise, {
        loading: "Actualizando...",
        success: "Comanda Actualizando!",
        error: "Uh oh, there was an error!",
      })
      .finally(() => {
        refresh();
      });
  };

  useEffect(() => {
    refresh();
  }, []);

  useEffect(() => {
    if (orders && orders.length > 0) {
      let newItems = [];
      orders.forEach((element) => {
        if (!alreadyPlay.find((list) => list === element._id)) {
          newItems.push(element._id);
        }
      });

      if (newItems.length > 0) {
        setAlreadyPlay([...alreadyPlay, ...newItems]);
        start();
      }
    }
  }, [orders]);

  const refresh = async () => {
    try {
      const promiseKOT = axios.get(`${api}kot/all`, {
        params: {
          business: process.env.REACT_APP_BUSINESS,
          status: "PENDING",
          start: moment()
            .startOf("day")
            .tz("America/El_Salvador")
            .tz("UTC")
            .format("YYYY-MM-DD HH:mm:ss"),
          end: moment()
            .endOf("day")
            .tz("America/El_Salvador")
            .tz("UTC")
            .format("YYYY-MM-DD HH:mm:ss"),
        },
      });
      const promiseOrders = axios.get(`${api}order/all-commands`, {
        params: {
          business: process.env.REACT_APP_BUSINESS,
          status: ["5eb509db3390527550d48e18", "5f27370f7bf6649bd46e3070"],
          start: moment()
            .startOf("day")
            .tz("America/El_Salvador")
            .tz("UTC")
            .format("YYYY-MM-DD HH:mm:ss"),
          end: moment()
            .add(30, "minutes")
            .tz("America/El_Salvador")
            .tz("UTC")
            .format("YYYY-MM-DD HH:mm:ss"),
        },
      });

      const promise = axios.all([promiseKOT, promiseOrders]).then(
        axios.spread((...responses) => {
          const responseKOT = responses[0].data;
          const responseOrders = responses[1].data;

          const elementos = [
            ...responseOrders.filter(
              (list) =>
                list.status.name !== "Completada" &&
                list.status.name !== "Cancelada" &&
                list.items.length > 0
            ),
            ...responseKOT.map((r) => {
              return {
                ...r,
                type: "kot",
              };
            }),
          ].sort(function (a, b) {
            return new Date(b.createdAt) - new Date(a.createdAt);
          });
          if(params.device === 'desktop') {
            setOrders(elementos.sort(function (a, b) {
              return new Date(a.id) - new Date(b.id);
            }));
          } else {
            setOrders(elementos);
          }
        })
      );

      toast.promise(promise, {
        loading: "Cargando...",
        success: "Carga completada!",
        error: "Uh oh, there was an error!",
      });
    } catch (error) {
      toast.error("Error en la carga");
    }
  };

  useEffect(() => {
    var audio = document.getElementById("myAudio");
    if (audio.paused) {
      setSound(false);
      setWorking(false);
    }
  }, []);

  const getExtraName = (order) => {
    if (order.thirdDelivery) {
      return `: DELIVERY APPs`;
    }

    if (order.delivery || order.isOwnDelivery) {
      return `: DELIVERY PROPIO`;
    }

    if (order.placement) {
      return `: ${order.placement.name}`;
    }

    if (order.isPickUp) {
      return `: PARA LLEVAR`;
    }

    if (order.order) {
      if (order.order.thirdDelivery) {
        return `: DELIVERY APPs`;
      }

      if (order.order.delivery) {
        return `: DELIVERY PROPIO`;
      }

      if (order.order.placement) {
        return `: ${order.order.placement.name}`;
      }

      if (order.order.isPickUp) {
        return `: PARA LLEVAR`;
      }
    }
  };

  const Container = params.device === 'desktop' ? MansoryLayout : DefaultLayout

  return (
    <div style={{ overflow: "auto" }}>
      <Container className={cx(styles.orders, params.device === 'desktop' && styles.ordersDesktop)}>
        {orders.map((order) => {
          return (
            <div
              className={cx(
                styles.existingOrder,
                order.status.name === "Completada" && styles.complete
              )}
              key={order._id}
            >
              <div className={styles.order}>
                <div
                  className={cx(
                    styles.orderSeq,
                    order.type === "kot" && styles.kot
                  )}
                >
                  #{order.id ? order.id : order.order ? order.order.id : ""}
                  {getExtraName(order)}
                  {order.status.name !== "Completada" && (
                    <div className={styles.orderTime}>
                      {returnTime(order.createdAt)}
                    </div>
                  )}
                </div>
                <div className={styles.orderDetalle}>
                  {order.items.map((or, i) => {
                    return (
                      <div className={cx(styles.orderItem)} key={`${i}-order`}>
                        <div className={styles.qty}>{or.qty}</div>
                        <div className={styles.producto}>
                          <div className={styles.name}>{or.item.name}</div>
                          {or.item.selectedAttributes &&
                            or.item.selectedAttributes.map((attribute, i) => {
                              if (attribute.value) {
                                let tempText =
                                  or.item.attributes.length > 0 &&
                                  or.item.attributes.find(
                                    (list) => list._id === attribute._id
                                  );

                                return (
                                  <span key={attribute._id} className={styles.attributeGrid}>
                                    <b>{tempText ? tempText.title : ""}</b>
                                    <ul>
                                      <li className={styles.attributeListDescription}>
                                        <span className={styles.attributeTitle}>
                                          {attribute.childValue.title}
                                        </span>
                                        {(attribute.childValue.description) && (
                                          <span
                                            className={
                                              styles.attributeDescription
                                            }
                                          >
                                            [{attribute.childValue.description}]
                                          </span>
                                        )}
                                      </li>
                                    </ul>
                                  </span>
                                );
                              } else if (attribute.multiple?.length > 0) {
                                let tempText =
                                  or.item.attributes.length > 0 &&
                                  or.item.attributes.find(
                                    (list) => list._id === attribute._id
                                  );
                                return (
                                  <span key={attribute._id} className={styles.attributeGrid}>
                                    <b>{tempText ? tempText.title : ""}</b>
                                    <ul>
                                      {attribute.multiple.map((m, i) => {
                                        return <li>{m.title}</li>;
                                      })}
                                    </ul>
                                  </span>
                                );
                              }
                            })}

                          {or.instructions && (
                            <span key={or.item._id}>
                              <b>{"Instrucciones"}</b>: {or.instructions}
                            </span>
                          )}
                        </div>
                      </div>
                    );
                  })}
                  {order.points?.length > 0 && (
                    <div>
                      <hr />
                      {order.points.map((point, i) => {
                        return (
                          <div
                            className={cx(styles.orderItem)}
                            key={`${i}-point`}
                          >
                            <div className={styles.qty}>-</div>
                            <div className={styles.producto}>
                              <div className={styles.name}>{point.name}</div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                  <div className={cx(styles.orderItem, styles.orderFooter)}>
                    <div className="qty"></div>
                    <div className={styles.producto}></div>
                  </div>
                  <div className={styles.formGroup}>
                    <label htmlFor="" style={{ width: "100%" }}>
                      Indicaciones Especiales Generales
                    </label>
                    <div className="text" style={{ color: "#EA2027" }}>
                      {order.description}
                    </div>
                  </div>
                </div>
                <div className={styles.orderFooter}>
                  {order.type === "kot" && (
                    <div
                      onClick={() => delivered(order._id)}
                      className={styles.btnCompleted}
                    >
                      ENTREGADA
                    </div>
                  )}
                </div>
              </div>
            </div>
          );
        })}
        {orders.length === 0 && (
          <div className={styles.noPending}>Sin ordenes pendientes</div>
        )}
        <div
          className={styles.refresh}
          onClick={() => {
            refresh();
            // setAlreadyPlay([]);
          }}
        >
          <i className="far fa-sync"></i>
        </div>
        <div
          className={styles.play}
          onClick={() => {
            start();
          }}
        >
          <i className="fas fa-play"></i>
        </div>
        {(sound === true && params.device !== 'desktop') && (
          <div className={styles.vista} onClick={() => stop()}>
            VISTA
          </div>
        )}
        {!working && (
          <div className={styles.initWork} onClick={() => initWork()}>
            INICIAR
          </div>
        )}
      </Container>
      <audio
        id="myAudio"
        controls
        style={{ visibility: "hidden", position: "absolute", right: 0 }}
      >
        <source src="/Autopilot-disconnect.mp3" type="audio/mpeg" />
      </audio>
    </div>
  );
}
